import type { ApiClient } from "../../api";
import * as sdk from "../../api/generated";
import { idempotencyHeaders } from "../../api/idempotency";

export type SubstitutionInput = sdk.PostApiV1DocumentWorkflowSubstitutionsBody;

export class SubstitutionsApi {
  constructor(private readonly client: ApiClient) {}

  list(query: sdk.GetApiV1DocumentWorkflowSubstitutionsQuery = {}) {
    return sdk.getApiV1DocumentWorkflowSubstitutions(this.client, { query });
  }

  async candidates(access_scope_id: string, user_id: string) {
    return (
      await sdk.getApiV1DocumentWorkflowSubstitutionsCandidates(this.client, {
        query: { access_scope_id, user_id },
      })
    ).data;
  }

  async create(body: SubstitutionInput, key: string) {
    return (
      await sdk.postApiV1DocumentWorkflowSubstitutions(this.client, {
        body,
        headers: idempotencyHeaders(key),
      })
    ).data;
  }

  async cancel(substitution: string, key: string) {
    return (
      await sdk.postApiV1DocumentWorkflowSubstitutionsBySubstitutionCancel(
        this.client,
        { path: { substitution }, headers: idempotencyHeaders(key) },
      )
    ).data;
  }
}
